import * as angular from 'angular';
import {IController} from "angular";

export class RoutesLoadingSettingsPanelCtrl implements IController {
  settings: any;
  onSettingsChange: Function;

  constructor(private $mdPanel) {
  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          routesAutomation: this.settings.routesAutomation,
          routesAutomationTime: this.settings.routesAutomationTime,
          routeColumnAutomation: this.settings.routeColumnAutomation,
          routeColumnAutomationTime: this.settings.routeColumnAutomationTime,
          idType: this.settings.idType,
          orderType: this.settings.orderType,
          showNotPacked: this.settings.showNotPacked,
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: DeliveriesSettingsCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/lean-planning/components/routes-loading-settings-panel/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel, reason) {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  function

  onClosePanel(settingsConfig, parentScope) {
    parentScope.onSettingsChange({
      settings: settingsConfig
    })
  }
}

export class DeliveriesSettingsCtrl implements IController {

  public columnsPermissions: any = {
    load: 'fleetManagement.vehicles.list',
    price: 'priceplan.list'
  };
  public settingsConfig: any;

  constructor(private mdPanelRef) {
    this.settingsConfig = {
      routesAutomation: this.mdPanelRef.config.locals.data.routesAutomation,
      routesAutomationTime: this.mdPanelRef.config.locals.data.routesAutomationTime,
      routeColumnAutomation: this.mdPanelRef.config.locals.data.routeColumnAutomation,
      routeColumnAutomationTime: this.mdPanelRef.config.locals.data.routeColumnAutomationTime,
      idType: this.mdPanelRef.config.locals.data.idType,
      orderType: this.mdPanelRef.config.locals.data.orderType,
      showNotPacked: this.mdPanelRef.config.locals.data.showNotPacked,
    };
  }

  onRoutesAutomationChange(routesAutomation) {
    this.settingsConfig.routesAutomation = routesAutomation;
    this.settingsConfig.routesAutomationTime = routesAutomation === 'MANUAL' ? undefined : 1;
  }

  // onChangeRoutesColumnAutomation(routeColumnAutomation) {
  //   this.settingsConfig.routeColumnAutomation = routeColumnAutomation;
  // }
  //
  // onChangeIdType(idType) {
  //   this.settingsConfig.idType = idType;
  // }
  //
  // onChangeOrderType(orderType) {
  //   this.settingsConfig.orderType = orderType;
  // }

  onReset() {
    this.settingsConfig = {
      routesAutomation: 'MANUAL',
      routesAutomationTime: 1,
      routeColumnAutomation: 'MANUAL',
      routeColumnAutomationTime: 1,
      idType: 'id',
      orderType: 'ORDER',
      showNotPacked: true
    };
    this.submit()
  }

  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      mdPanelRef.config.locals.onClose(this.settingsConfig, this.mdPanelRef.config.locals.data.parentScope);
    })
  }

  cancel() {
    this.mdPanelRef.close();
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('routesLoadingSettingsPanel', {
    bindings: {
      settings: '<',
      onSettingsChange: '&'
    },
    template: require('./routes-loading-settings-panel.html').default,
    controller: RoutesLoadingSettingsPanelCtrl
  });
